import { useQuery } from "@tanstack/react-query";
import * as filestack from "filestack-js";
import { useMemo } from "react";
import { fetchFilestackConfig } from "../api/client";

export function useFilestack(): filestack.Client | undefined {
  const checkAuthResult = useQuery({
    queryKey: ["filestackConfig"],
    queryFn: () => fetchFilestackConfig(),
  });

  const filestack = useMemo(() => {
    if (checkAuthResult.isSuccess) {
      return createFilestackClient(
        checkAuthResult.data?.workspace_files_api_key,
        {
          security: checkAuthResult.data?.workspace_files_security,
        },
      );
    } else {
      return undefined;
    }
  }, [checkAuthResult.isSuccess, checkAuthResult.data]);

  return filestack;
}

/**
 * Create a filestack client with environment variables and default configuration plus additional given options.
 */
export function createFilestackClient(
  apiKey: string,
  options: filestack.ClientOptions = {},
): filestack.Client {
  const key = apiKey ?? import.meta.env.VITE_FILESTACK_API_KEY;
  const cname = import.meta.env.VITE_FILESTACK_CNAME ?? "files.smartsuite.com";

  if (!key) {
    throw new Error("filestack API key is not set");
  }

  if (!cname) {
    throw new Error(
      "REACT_APP_FILESTACK_CNAME environment variable is not set",
    );
  }

  return filestack.init(key, { cname, ...options });
}
